import Url from './url';

/**
 * Wraps base URL, adds query parameters if there are any possible ones.
 * Gets parameter value from passed values (usually, from props).
 * Can convert original name to different query parameter name.
 *
 * @param baseUrl
 * @param params — array of possible params, value can be either:
 * - string — query parameter would have the same name as passed parameter
 * - object - a map to convert the parameter name,
 *            where key is the name of passed parameter and value is
 *            query parameter name. Such map should be defined as last item.
 * e.g.: ['orderNo', 'paramTwo', { propOne: queryThree, propTwo: queryFour }]
 *
 * @returns wrapper function
 */
export function urlWrapper(baseUrl, params = []) {
  return function getUrlWithQueryParams({ ...paramValues } = {}) {
    if (!params.length) {
      return baseUrl;
    }

    const url = new Url(baseUrl);
    const urlParams = {};

    params.forEach(param => {
      if (typeof param === 'object') {
        for (const key of Object.keys(param)) {
          if (key in paramValues) {
            urlParams[param[key]] = paramValues[key];
          }
        }
      } else if (param in paramValues) {
        urlParams[param] = paramValues[param];
      }
    });
    return url.addQueryParameters(urlParams).toString();
  };
}
